import { isRequired } from '@gef-ui/form-core/validations/validationFunctions/common';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { isDateNotInFuture, isDateWithOrder, isFullySpecifiedDate } from 'app/forms/validations/common';
import isBirthNumber from 'app/forms/validations/isBirthNumber';
import isBusinessIn from 'app/forms/validations/isBusinessIn';
import isBusinessName from 'app/forms/validations/isBusinessName';
import isFirstName from 'app/forms/validations/isFirstName';
import isLogin from 'app/forms/validations/isLogin';
import isMunicipality from 'app/forms/validations/isMunicipality';
import isNumber from 'app/forms/validations/isNumber';
import isPolicyNo from 'app/forms/validations/isPolicyNo';
import isSurname from 'app/forms/validations/isSurname';
import isZipCode from 'app/forms/validations/isZipCode';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

import { noneOfRequiredFieldsFilled } from './utils';

export const TASK_SEARCH_FORM_NAME = 'taskSearch-filter';

const {
	policyNumber,
	businessName,
	firstName,
	surname,
	personIn,
	businessIn,
	municipality,
	zipCode,
	taskType,
	taskSubTypeId,
	login,
} = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	policyNumber,
	taskType,
	taskSubTypeId,
	id: 'id',
	statusId: 'statusId',
	finishTypeId: 'finishTypeId',
	surname,
	firstName,
	personIn,
	businessName,
	businessIn,
	municipality,
	zipCode,
	login,
	queueGroupCd: 'queueGroupCd',
	createdFrom: 'createdFrom',
	createdTo: 'createdTo',
};

export default () => ({
	[FIELDS.policyNumber]: {
		deepPath: [FIELDS.policyNumber],
		validations: [
			isRequired({
				when: ({ formData }) => noneOfRequiredFieldsFilled(formData),
			}),
			isNumber({ customMessage: getLabelMessage('validation:allowedCharacters') }),
			isPolicyNo(),
		],
	},
	[FIELDS.taskType]: {
		deepPath: [FIELDS.taskType],
		validations: [
			isRequired({
				when: ({ formData }) => noneOfRequiredFieldsFilled(formData),
			}),
		],
	},
	[FIELDS.taskSubTypeId]: {
		deepPath: [FIELDS.taskSubTypeId],
		validations: [],
	},
	[FIELDS.id]: {
		deepPath: [FIELDS.id],
		validations: [
			isRequired({
				when: ({ formData }) => noneOfRequiredFieldsFilled(formData),
			}),
			isNumber(),
		],
	},
	[FIELDS.statusId]: {
		deepPath: [FIELDS.statusId],
		validations: [],
	},
	[FIELDS.finishTypeId]: {
		deepPath: [FIELDS.finishTypeId],
		validations: [],
	},
	[FIELDS.surname]: {
		deepPath: [FIELDS.surname],
		validations: [
			isRequired({
				when: ({ formData }) => noneOfRequiredFieldsFilled(formData),
			}),
			isSurname(),
		],
	},
	[FIELDS.firstName]: {
		deepPath: [FIELDS.firstName],
		validations: [isFirstName()],
	},
	[FIELDS.personIn]: {
		deepPath: [FIELDS.personIn],
		validations: [
			isRequired({
				when: ({ formData }) => noneOfRequiredFieldsFilled(formData),
			}),
			isBirthNumber(),
		],
	},
	[FIELDS.businessName]: {
		deepPath: [FIELDS.businessName],
		validations: [
			isRequired({
				when: ({ formData }) => noneOfRequiredFieldsFilled(formData),
			}),
			isBusinessName(),
		],
	},
	[FIELDS.businessIn]: {
		deepPath: [FIELDS.businessIn],
		validations: [
			isRequired({
				when: ({ formData }) => noneOfRequiredFieldsFilled(formData),
			}),
			isBusinessIn(),
		],
	},
	[FIELDS.municipality]: {
		deepPath: [FIELDS.municipality],
		validations: [isMunicipality()],
	},
	[FIELDS.zipCode]: {
		deepPath: [FIELDS.zipCode],
		validations: [isZipCode()],
	},
	[FIELDS.login]: {
		deepPath: [FIELDS.login],
		validations: [
			isRequired({
				when: ({ formData }) => noneOfRequiredFieldsFilled(formData),
			}),
			isLogin(),
		],
	},
	[FIELDS.queueGroupCd]: {
		deepPath: [FIELDS.queueGroupCd],
		validations: [isLogin()],
	},
	[FIELDS.createdFrom]: {
		deepPath: [FIELDS.createdFrom],
		dependentFields: [FIELDS.createdTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.createdFrom, toFieldName: FIELDS.createdTo }),
			isDateNotInFuture(),
		],
	},
	[FIELDS.createdTo]: {
		deepPath: [FIELDS.createdTo],
		dependentFields: [FIELDS.createdFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.createdFrom, toFieldName: FIELDS.createdTo }),
			isDateNotInFuture(),
		],
	},
});
